import React from "react";

interface ProposalAreaOfferedcardDetailsProps {
    groupedProperties: any[];
}

export default function ProposalAreaOfferedcardDetails({ groupedProperties }: ProposalAreaOfferedcardDetailsProps) {
    return (
        <>
            <tr>
                <td
                    style={{
                        fontSize: "15px",
                        fontWeight: 700,
                        padding: " 0 15px",
                    }}
                >
                    <u>
                        {" "}
                        FLOOR & OFFICE AREA OFFERED (In
                        Sq. Ft.)
                    </u>
                </td>
            </tr>
            <tr>
                <td height="9"></td>
            </tr>
            <tr>
                <td
                    style={{
                        fontSize: "15px",
                        padding: " 0 15px",
                    }}
                >
                    <table
                        width="100%"
                        cellPadding="0"
                        cellSpacing="0"
                        style={{ fontSize: "15px" }}
                    >
                        <tr>
                            <td width="50%">
                                <table
                                    width="100%"
                                    cellPadding="0"
                                    cellSpacing="0"
                                >
                                    <tbody>
                                        <tr>
                                            <td
                                                style={{
                                                    color:
                                                        "#5E5E5E",
                                                }}
                                            >
                                                <ul className="list-unstyled"
                                                    style={{
                                                        columns: "2",
                                                    }}>
                                                    {groupedProperties
                                                        ?.map(
                                                            (item: {
                                                                floorOffered: number;
                                                                totalBuiltArea: number;
                                                            }) => (
                                                                <>
                                                                    <li
                                                                        //  className="col-md-6" 
                                                                        style={{ marginBottom: "4px", display: "flex", justifyContent: "space-between" }}>

                                                                        <span style={{ color: "#5e5e5e", fontSize: "14px", }}>
                                                                            {/* {getFloorLabel(
                                                            item.floorNumber
                                                          )} */}
                                                                            {item?.floorOffered}
                                                                        </span>

                                                                        <span
                                                                            style={{
                                                                                color: "#000",
                                                                                fontSize: "14px",
                                                                            }}
                                                                        >

                                                                            {/* {item.unitArea.toFixed(
                                                            2
                                                          )} */}
                                                                            :{item?.totalBuiltArea}
                                                                        </span>
                                                                    </li>
                                                                </>
                                                            )
                                                        )}
                                                </ul>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                    </table>
                </td>
            </tr>
        </>
    );
}
